import React, { ReactElement } from 'react';
import { Empty } from 'antd';

import { testId } from 'pricing/utilities/test/dataTestId';
import { ContractNotFoundWrapper } from './ContractNotFound.styles';

function ContractNotFound(): ReactElement {
  return (
    <ContractNotFoundWrapper data-testid={testId.contractNotFound}>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Contract not found" />
    </ContractNotFoundWrapper>
  );
}

export default ContractNotFound;
